import React from 'react';
import { AiOutlineFile } from 'react-icons/ai';

import { ReactComponent as Delete } from '../../../assets/icons/ubr_delete.svg';
import Button from '../../Button';
import { Container, FileInfo } from './styles';

interface FileProps {
  id?: any;
  name: string;
  readableSize: string;
}

interface FileListProps {
  files: FileProps[];
  handleErase?: any;
}

const FileList = ({ files, handleErase = () => {} }: FileListProps) => {
  return (
    <Container>
      {files.map(uploadedFile => (
        <div key={uploadedFile.name}>
          <FileInfo>
            <AiOutlineFile size={16} />
            <div>
              <strong>
                {uploadedFile.name.length > 20
                  ? uploadedFile.name.substring(0, 20 - 3) + '...'
                  : uploadedFile.name}
              </strong>
              <span>{uploadedFile.readableSize}</span>
            </div>
            <Button
              variant="solid-icon"
              color={'#C71F37'}
              size={'small'}
              tooltipText={'Excluir'}
              onClick={() => {
                setTimeout(() => {
                  handleErase(uploadedFile.id);
                }, 500);
              }}
            >
              <Delete style={{ width: '20px' }} />
            </Button>
          </FileInfo>
        </div>
      ))}
    </Container>
  );
};

export default FileList;
